export const FETCH_LIST_START = "FETCH_LIST_START";
export const FETCH_LIST_SUCCESS = "FETCH_LIST_SUCCESS";
export const FETCH_LIST_FAIL = "FETCH_LIST_FAIL";

export const FETCH_WORKSHOP_DROPDOWN_START = "FETCH_WORKSHOP_DROPDOWN_START";
export const FETCH_WORKSHOP_DROPDOWN_SUCCESS = "FETCH_WORKSHOP_DROPDOWN_SUCCESS";
export const FETCH_WORKSHOP_DROPDOWN_FAIL = "FETCH_WORKSHOP_DROPDOWN_FAIL";

export const FETCH_FILTERS = "FETCH_FILTERS";

export const FETCH_EXTERNAL_SERVICES_START = "FETCH_EXTERNAL_SERVICES_START";
export const FETCH_EXTERNAL_SERVICES_SUCCESS = "FETCH_EXTERNAL_SERVICES_SUCCESS";
export const FETCH_EXTERNAL_SERVICES_FAIL = "FETCH_EXTERNAL_SERVICES_FAIL";

export const FETCH_ORDER_VENDOR_START = "FETCH_ORDER_VENDOR_START";
export const FETCH_ORDER_VENDOR_SUCCESS = "FETCH_ORDER_VENDOR_SUCCESS";
export const FETCH_ORDER_VENDOR_FAIL = "FETCH_ORDER_VENDOR_FAIL";
